module.exports = __webpack_public_path__ + "static/media/icon_32x32.1df7fbfa.png";